var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgWifi = function SvgWifi(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 23 17"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#656565",
    clipPath: "url(#wifi_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.676 5.363c2.607-2.477 6.14-3.869 9.824-3.869 3.683 0 7.217 1.391 9.823 3.87a.713.713 0 0 0 .974.003.633.633 0 0 0 .003-.927C19.432 1.718 15.55.19 11.5.19S3.566 1.72.7 4.44a.635.635 0 0 0 .003.927c.27.254.705.253.973-.004"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.57 8.636a.7.7 0 0 0 .49-.189.633.633 0 0 0 0-.91c-2.008-1.908-4.726-2.98-7.563-2.98S5.943 5.63 3.935 7.538a.65.65 0 0 0-.24.47.64.64 0 0 0 .202.489.71.71 0 0 0 1.008-.037c1.751-1.66 4.122-2.593 6.592-2.593 2.471 0 4.842.932 6.593 2.593.13.116.304.18.48.177M15.346 11.72a.72.72 0 0 0 .488-.19.637.637 0 0 0 0-.93 6.3 6.3 0 0 0-4.332-1.703c-1.624 0-3.18.613-4.332 1.704a.637.637 0 0 0 0 .928c.269.257.707.257.975 0 1.854-1.76 4.857-1.76 6.711 0 .13.124.305.191.487.191zM10.405 13.684a1.424 1.424 0 0 0 0 2.082c.607.566 1.58.566 2.186 0a1.424 1.424 0 0 0-.037-2.047 1.603 1.603 0 0 0-2.149-.035"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "wifi_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M.5.19h22v16H.5z"
  })))));
};
export default SvgWifi;